export type CurrentLocationErrorKey =
  | 'permissionDenied'
  | 'locationUnavailable'
  | 'locationTimeout';

export interface CurrentCoordinates {
  lat: number;
  lng: number;
}

export class CurrentLocationError extends Error {
  constructor(public readonly translationKey: CurrentLocationErrorKey) {
    super(translationKey);
    this.name = 'CurrentLocationError';
    Object.setPrototypeOf(this, CurrentLocationError.prototype);
  }
}

const getBrowserGeolocation = (): Geolocation | undefined => {
  if (typeof navigator === 'undefined') return undefined;
  return navigator.geolocation;
};

export const isGeolocationSupported = (): boolean =>
  Boolean(getBrowserGeolocation());

export const getCurrentLocation = (
  geolocation: Geolocation | null | undefined = getBrowserGeolocation(),
): Promise<CurrentCoordinates> => {
  if (!geolocation) {
    return Promise.reject(new CurrentLocationError('locationUnavailable'));
  }

  return new Promise((resolve, reject) => {
    geolocation.getCurrentPosition(
      (position) =>
        resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        }),
      (error) => {
        const translationKey: CurrentLocationErrorKey =
          error.code === 1
            ? 'permissionDenied'
            : error.code === 3
              ? 'locationTimeout'
              : 'locationUnavailable';
        reject(new CurrentLocationError(translationKey));
      },
      {
        enableHighAccuracy: true,
        timeout: 10_000,
        maximumAge: 0,
      },
    );
  });
};
